// extracted by mini-css-extract-plugin
export default {"black":"fPLfRdZbdURFtETYO3MA","white":"scyULkA0CXqmDiWzjLwm"};